import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

import {
  FiWifi,
  FiCoffee,
  FiMonitor,
  FiSun,
  FiVolume2,
  FiMapPin,
  FiHeart,
  FiDroplet,
  FiUsers,
  FiBox,
  FiPrinter,
  FiPhone,
  FiLock,
  FiMail,
  FiCalendar,
  FiTruck,
  FiClock,
} from 'react-icons/fi';

const AmenitiesSection = props => {
  const { languageData, spaceData } = props;

  const amenitiesLeft = [
    {
      condition: true,
      icon: <FiWifi />,
      en: 'Fast, secure WiFi',
      es: 'WiFi rápido y seguro',
    },
    {
      condition: spaceData?.coffe_water === '1',
      icon: <FiCoffee />,
      en: 'Complimentary coffee & tea',
      es: 'Café y té de cortesía',
    },
    {
      condition: spaceData?.printing_service === '1',
      icon: <FiPrinter />,
      en: 'Printing & Scanning',
      es: 'Impresión y escaneo',
    },
    {
      condition: spaceData?.cleaning_service === '1',
      icon: <FiSun />,
      en: 'Cleaning Service',
      es: 'Servicio de limpieza',
    },
    {
      condition: spaceData?.common_areas === '1',
      icon: <FiUsers />,
      en: 'Common Areas',
      es: 'Áreas comunes',
    },
    {
      condition: spaceData?.staff === '1',
      icon: <FiUsers />,
      en: 'Staff',
      es: 'Personal',
    },
  ];

  const amenitiesRight = [
    {
      condition: spaceData?.parking === '1',
      icon: <FiMapPin />,
      en: 'Parking',
      es: 'Estacionamiento',
    },
    {
      condition: spaceData?.phone_service === '1',
      icon: <FiPhone />,
      en: 'Phone Booths',
      es: 'Cabinas telefónicas',
    },
    {
      condition: spaceData?.snacks === '1',
      icon: <FiDroplet />,
      en: 'Snacks',
      es: 'Snacks',
    },
    {
      condition: spaceData?.convention_hall === '1',
      icon: <FiMonitor />,
      en: 'Conference Room',
      es: 'Sala de conferencias',
    },
  ];

  const addOns = [
    {
      condition: spaceData?.convention_hall === '1',
      icon: <FiCalendar />,
      en: 'Conference Rooms',
      es: 'Salas de conferencia',
    },
  ];

  const renderItem = item => (
    <FlexContainer className="align-items-center margb12">
      <div
        style={{
          color: 'white',
          fontSize: 18,
          opacity: 0.9,
          marginRight: 24,
        }}
      >
        {item.icon}
      </div>

      <Label
        className="text-13"
        style={{
          opacity: 0.9,
          fontWeight: 600,
        }}
      >
        {languageData === 'EN' ? item.en : item.es}
      </Label>
    </FlexContainer>
  );

  return (
    <FlexContainer className="width100 bgGradientReviewBlue180 borderrad14 pad24 flex-column">
      <Label
        className="text-18 margb8"
        style={{
          fontWeight: 700,
        }}
      >
        {languageData === 'EN' ? 'Amenities' : 'Amenidades'}
      </Label>

      <Label
        className="text-14 margb16"
        style={{
          fontWeight: 600,
        }}
      >
        {languageData === 'EN' ? 'Coworking Space' : 'Espacio de Coworking'}
      </Label>

      <FlexContainer className="width100 justify-content-between">
        <FlexContainer className="flex-column width50">
          {amenitiesLeft
            .filter(item => item.condition)
            .map((item, index) => (
              <div key={index}>{renderItem(item)}</div>
            ))}
        </FlexContainer>

        <FlexContainer className="flex-column width50">
          {amenitiesRight
            .filter(item => item.condition)
            .map((item, index) => (
              <div key={index}>{renderItem(item)}</div>
            ))}

          {addOns.filter(item => item.condition).length > 0 && (
            <>
              <Label
                className="text-14 margt16 margb10"
                style={{
                  fontWeight: 600,
                }}
              >
                {languageData === 'EN' ? 'Add Ons' : 'Extras'}
              </Label>

              {addOns
                .filter(item => item.condition)
                .map((item, index) => (
                  <div key={index}>{renderItem(item)}</div>
                ))}
            </>
          )}
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default AmenitiesSection;
